{# free slot between the "product information" card (article number) and the "prices" card (price) #}
{% block sw_product_detail_base_price_card %}

    <product-detail-product-boxes-settings></product-detail-product-boxes-settings>

    {% parent %}

{% endblock %}
